<template>
  <v-layout v-resize="onResize">
    <v-flex xl12 lg12 md12 sm12 xs12>
      <v-menu
        v-model="menu"
        offset-y
        :min-width="(isMobile) ? responsiveWidth : 850"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            solo
            class="barsearch"
            @input="getCompanyListDeboucne"
            @blur="open=true;close=false"
            v-model="searchValue"
            placeholder="Search"
            hide-details
            :autofocus="(isMobile) ? true : false"
            autocomplete="off"
            color="black"
            clearable>
          </v-text-field>
        </template>
        <v-card flat class="pa-1 pt-2">
          <v-layout v-if="searchValue.length < 2" wrap>
            <v-flex xl12 lg12 md12 sm12 xs12 class="mx-0 px-0">
              <p class="subtitle-1 mb-0">Please enter 2 characters or more.</p>
            </v-flex>
          </v-layout>
          <v-layout v-if="searchingApi === false && companyList.length === 0 && searchValue.length >= 2" wrap>
            <v-flex xl12 lg12 md12 sm12 xs12 class="mx-0 px-0">
              <p class="subtitle-1 mb-0">No Record Found.</p>
            </v-flex>
          </v-layout>
          <div :style="`max-height: `+cardHeight+`px;overflow: auto;`">
            <v-layout wrap v-for="(data, index) in companyList" :key="index" class="result-row" @click="openCompanyDetail(data)">
              <v-flex xl12 lg12 md12 sm12 xs12 class="mx-0 px-0 c-pointer">
                <v-divider v-if="index > 0"></v-divider>
              </v-flex>
              <v-flex xl12 lg12 md12 sm12 xs12>
                <div class="d-flex">
                  <p class="mb-0 subtitle-1 primary--text wp-search-title">{{ data.companyName }}</p>
                </div>
                <div v-for="(customers, cind) in data.dealerCustomers" :key="cind" class="ml-2">
                  <p class="mb-0 font-weight-medium">{{ customers.companyName }}</p>
                  <div class="ml-3 grey--text">
                    <v-layout wrap v-for="(contact, index) in customers.ContactData" :key="index+'i'" class="d-flex align-i-center">
                      <v-icon size="15" color="grey">fas fa-user</v-icon>
                      <span class="body-2 mr-2 ml-1 font-weight-bold" v-html="matchFind(contact.Fname + ' ' + contact.Lname + ' ')"></span>
                      <v-icon size="15" color="grey" v-if="contact.Email.length > 0" class="mr-1">fas fa-envelope</v-icon>
                      <div v-for="(email, index) in contact.Email" :key="index+'e'">
                        <span class="body-2" v-html="matchFind(email)"></span>
                      </div>
                      <v-icon size="13" color="grey" v-if="contact.AllNumber.length > 0" class="mx-1">fas fa-phone</v-icon>
                      <div v-for="(number, index) in contact.AllNumber" :key="index+'n'">
                        <span class="body-2 mr-1" v-html="matchFind(number)"></span>
                      </div>
                    </v-layout>
                    <div v-for="(address, index) in customers.AddList" :key="index+'a'">
                      <v-icon size="15" color="grey">fas fa-map-marker-alt</v-icon>
                      <span class="body-2" v-html="matchFind(address)" style="word-break: break-all;white-space: pre-line;"></span>
                    </div>
                  </div>
                  <v-divider></v-divider>
                </div>
              </v-flex>
            </v-layout>
            <scroll-loader v-if="this.searchValue.length >= 2" :loader-method="loadMoreCompanyData" :loader-disable="disable"></scroll-loader>
          </div>
        </v-card>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
import CallCenterCrm from '@/api/CallCenterCrm'
import deboucneMixin from '@/mixins/debounce.js'
export default {
  data () {
    return {
      cardHeight: 600,
      getCompanyListDeboucne: null,
      menu: '',
      open: true,
      close: true,
      searchValue: '',
      isMobile: false,
      responsiveWidth: 350,
      searchingApi: false,
      totalCompany: 0,
      start: 0,
      length: 10,
      companyList: [],
      disable: false
    }
  },
  mixins: [deboucneMixin],
  mounted () {
    this.getCompanyListDeboucne = this.debounce(function () {
      this.menu = true
      this.companyList = []
      this.totalCompany = 0
      if (this.searchValue !== null) {
        if (this.searchValue.length >= 2) {
          this.searchWorkPakcage()
        }
      } else {
        this.searchValue = ''
      }
    }, 500)
  },
  watch: {
    searchValue: {
      handler () {
        if (this.searchValue === null) {
          this.companyList = []
          this.totalCompany = 0
        }
      },
      deep: true
    }
  },
  methods: {
    loadMoreCompanyData () {
      this.start = this.companyList.length
      this.searchWorkPakcage()
    },
    searchValueDefine () {
      // manipulate search value string for match and api call
      var serachValue = ''
      var serachNumber = []
      var operateValue = this.searchValue.replace(/-|\(|\)/g, ' ')
      let searchStrArray = operateValue.split(' ')
      for (let i = 0; i < searchStrArray.length; i++) {
        if (searchStrArray[i].trim() !== '') {
          if (searchStrArray[i].search('@') === -1) {
            var serachNumberTest = searchStrArray[i].replace(/-|\(|\)|\./g, '')
            if (isNaN(serachNumberTest) === false) {
              serachNumber.push(serachNumberTest)
            } else {
              serachValue += searchStrArray[i] + ' '
            }
          } else {
            serachValue += searchStrArray[i] + ' '
          }
        }
        if (serachNumber.length > 0 && serachNumber.length === 3) {
          if (serachNumber[0].length === 3 && serachNumber[1].length === 3 && serachNumber[2].length === 4) {
            var numberStr = serachNumber.join('')
            serachValue += numberStr + ' '
            serachNumber = []
          } else {
            for (let i = 0; i < serachNumber.length; i++) {
              serachValue += serachNumber[i] + ' '
            }
            serachNumber = []
          }
        }
      }
      if (serachNumber.length > 0) {
        for (let i = 0; i < serachNumber.length; i++) {
          serachValue += serachNumber[i] + ' '
        }
        serachNumber = []
      }
      return serachValue
    },
    matchFind (str) {
      if (str === null || str === undefined || str === ' ') {
        return
      }
      var serachValue = this.searchValueDefine()
      let searchStrArray = serachValue.split(' ')
      let replceString = str.trim()
      for (let i = 0; i < searchStrArray.length; i++) {
        if (searchStrArray[i].trim() !== '') {
          replceString = replceString.replace(new RegExp(searchStrArray[i], 'gi'), match => {
            return '<span class="highlightText black--text">' + match + '</span>'
          })
        }
      }
      return replceString
    },
    searchWorkPakcage () {
      this.searchingApi = true
      CallCenterCrm.globalCompanySearch(
        this.searchValue,
        this.start,
        this.length,
        response => {
          let companyList = (response.Data) ? response.Data : []
          for (let index = 0; index < companyList.length; index++) {
            companyList[index].dealerCustomers = JSON.parse(companyList[index].dealerCustomers).dealerCustomer
          }
          for (let i = 0; i < companyList.length; i++) {
            this.companyList.push(companyList[i])
          }
          // this.companyList.length < this.length && (this.disable = false)
          this.searchingApi = false
        },
        error => {
          console.log('error ', error)
        }
      )
    },
    openCompanyDetail (detail) {
      this.close = true
      this.open = true
      this.menu = false
      this.$router.push({name: 'Customerdetails', params: {companyMasterId: detail.companyMasterId}})
    },
    openCompanyDetailInNewTab (detail) {
      let routeData1 = this.$router.resolve({name: 'Customerdetails', params: {companyMasterId: detail.companyMasterId}})
      window.open(routeData1.href, '_blank')
    },
    onResize () {
      this.cardHeight = window.innerHeight - 200
      console.log('onResize')
      if (window.innerWidth <= 1264) {
        this.isMobile = true
        this.responsiveWidth = window.innerWidth - 15
      } else {
        this.isMobile = false
      }
    }
  }
}
</script>
<style scoped>
.project-title {
  width: calc(100% - 230px);
}
.wp-number {
  width: 50px;
}
.wp-status {
  width: 150px;
}
.wp-search-title {
  width: calc(100% - 20px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
 .result-row:hover {
      background-color: #fafafa;
  }
.barsearch {
  width: 350px;
}

.mobileSearch {
  width: 300px;
}
.filter-green {
   filter: invert(48%) sepia(79%) saturate(906%) hue-rotate(80deg) brightness(50%) contrast(20%) grayscale(200%);
}

</style>



// WEBPACK FOOTER //
// src/View/components/globalSearch.vue